// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

export default styled<any, Theme>('div')`
  align-items: center;
  background: ${props => props.theme.package.soldOut.background};
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  margin: -3px; /* tile border */
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
`;
